import CreateBindLayoutMapPage from "../../bind-layout-maps/create/page"

export default function CreateGISBindRobotMapScreen({
  onSubmit,
  onCancel
}: {
  onSubmit: () => void,
  onCancel: () => void
}) {
  return (
    <CreateBindLayoutMapPage
      onSubmit={() => {
        onSubmit()
      }}
      onCancel={() => {
        onCancel()
      }}
    />
  )
}